import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { googleLogout } from "@react-oauth/google";
import LoggedInImage from "../../../assets/images/loggedInUser.png";
import swal from "sweetalert";
import { toast } from "react-toastify";
import {
  VIEW_MENTOR_APPLICATION_DATA,
  VIEW_STARTUP_APPLICATION_DATA,
} from "../../common/constants/ApplicationUrl";

import api from "../../common/dependencies/utils/Api";
const Profile = (props) => {
  const { username } = props;
  
  let history = useHistory();
  const [data, setData] = useState();
  const imageUrl = "https://uat-nmp-api.startupindia.gov.in/v1/document/";
  const [saveAsDraftStatus, setSaveAsDraftStatus] = useState();
  const [applicationSatus, setApplicationStatus] = useState();

  const [profileImg, setProfileImg] = useState();

  useEffect(() => {
    try {
      let value = localStorage.getItem("SavedLoggedInData");
      let parsedData = JSON.parse(value);
      
      
      setData(JSON.parse(value));
      const params = {
        id:
          parsedData && parsedData.role === "Mentor"
            ? JSON.parse(localStorage.getItem("SavedLoggedInData")).id
            : parsedData && parsedData.role === "Startup"
            ? parsedData.dippNumber
            : "",
      };
      api
        .POST(
          `${
            parsedData && parsedData.role === "Mentor"
              ? VIEW_MENTOR_APPLICATION_DATA
              : VIEW_STARTUP_APPLICATION_DATA
          }`,
          params
        )
        .then((response) => {
          const { data, status } = response || {};
          if (status === 200) {
            
            if (response.data.data) {
              setApplicationStatus(response?.data?.data?.applicationStatus);
              if (response.data.data.applicationStatus === "DRAFT") {
                setSaveAsDraftStatus("DRAFT");
                if (parsedData.role === "Mentor") {
                  setProfileImg(response.data.data.uploadProfilePic);
                } else {
                  setProfileImg(response.data.data.upload_profile);
                }
              } else {
                if (parsedData.role === "Mentor") {
                  setProfileImg(response.data.data.uploadProfilePic);
                } else {
                  setProfileImg(response.data.data.upload_profile);
                }
              }
            }
          } else {
          }
        })
        .catch((e) => {});
    } catch (error) {}
  }, []);

  const logoutClick = () => {
    localStorage.clear();
    // window.FB.logout();
    googleLogout();
    localStorage.removeItem("SavedLoggedInData");
    localStorage.removeItem("loggedIn");
    // localStorage.clear();
    // sessionStorage.clear();
    // var cookies = document.cookie;

    // for (var i = 0; i < cookies.split(";").length; ++i)
    // {
    //     var myCookie = cookies[i];
    //     var pos = myCookie.indexOf("=");
    //     var name = pos > -1 ? myCookie.substr(0, pos) : myCookie;
    //     document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    // }
    // localStorage.removeItem("mentorMenu");
    // localStorage.removeItem("allMentorships");
    // localStorage.removeItem("allMentorList");
    // localStorage.removeItem("allStartupList");
    // localStorage.removeItem("startUpApplications");
    // localStorage.removeItem("cohortProgram");
    // localStorage.removeItem("cohortApplication");
    // localStorage.removeItem("cohortStartup");
    // localStorage.removeItem("cohortMentors");
    // localStorage.removeItem("cohortStartup");
    // localStorage.removeItem("cohortStartup");
    // localStorage.removeItem("cohortStartup");
    // window.localStorage.clear();

    // sessionStorage.removeItem("fbssls_");
    sessionStorage.clear();
    toast.success("User Logged Out", {
      position: "top-right",
      autoClose: 2000,
    });
    setTimeout(function () {
      history.push(`/login`);
    }, 1000);
    // run this after 3 seconds
  };
  const openDashboard = () => {
    try {
      
      if (localStorage.getItem("loggedIn") === "true") {
        let value = localStorage.getItem("SavedLoggedInData");
        let LoginFormData = JSON.parse(value);
        if (LoginFormData?.role == "Startup") {
          history.push({
            pathname: "/startup-dashboard",
            state: LoginFormData,
          });

          localStorage.removeItem("myRequests");
          localStorage.removeItem("startupAllMentorList");
          localStorage.removeItem("mentorStartupRequest");
          localStorage.removeItem("startUpRequests");
          localStorage.removeItem("CohortStartupRequest");
          localStorage.removeItem("cohortMentorshipsStartup");

          window.location.reload();

          // history.push({
          //   pathname: "/get-a-mentor",
          //   state: LoginFormData,
          // });
        } else if (LoginFormData?.role == "Mentor") {
          // need to add condition which page need to show
          if (LoginFormData.applicationSatus === "PENDING") {
            history.push({
              pathname: "/become-a-mentor",
              state: LoginFormData,
            });
          } else {
            history.push({
              pathname: "/dashboard",
              state: LoginFormData,
            });

            localStorage.setItem("mentorDashboardHome", "mentorDashboardHome");
            window.location.reload();
          }
        } else if (LoginFormData?.role == "Admin") {
          history.push({
            pathname: "/dashboard",
          });
          localStorage.setItem("adminMenu", "adminMenu");
          localStorage.removeItem("mentorMenu");
          localStorage.removeItem("startupMentorAllMentorships");
          localStorage.removeItem("allMentorList");
          localStorage.removeItem("allMentorsMentorship");
          localStorage.removeItem("startUpApplications");
          localStorage.removeItem("allStartupList");
          localStorage.removeItem("allMentorships");
          localStorage.removeItem("cohortApplication");
          localStorage.removeItem("cohortProgram");
          window.location.reload();
        }
      } else {
        history.push({
          pathname: "/login",
        });
      }
    } catch (error) {}
  };
  return (
    <div
      style={{
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
      className="mainformdiv"
    >
      <div className="tooltip1 text-end d-none d-xl-block">
        <div className="d-flex justify-content-end">
          <img
            src={LoggedInImage}
            style={{ float: "right", height: "50px", cursor: "pointer" }}
          />
        </div>
        {/* <a className="thm-btn brd-btn rounded-pill d-inline-block" style={{ cursor: "pointer" }} title="">
          Log Out
        </a> */}
        <div className="d-flex justify-content-end titleTopHeading">
          <h5 className="card-title2">Welcome {username}</h5>
        </div>
        <span id="profileDrop" className="tooltiptext1-profile">
          <div className="col-md-12 animated fadeIn">
            <div className="card">
              <div className="card-body">
                <div className="avatar">
                  {/* {alert(profileImg)} */}
                  <img
                    src={
                      profileImg
                        ? profileImg
                        : data?.image && data?.image
                        ? data?.image
                        : LoggedInImage
                    }
                    className="card-img-top"
                    alt=""
                  />
                </div>
                <h5 className="card-title">{data?.applicant_name}</h5>
                {saveAsDraftStatus === "DRAFT" ||applicationSatus==="SUBMITTED"|| applicationSatus==="DRAFT"|| data?.role === "Admin" ? (
                  <h5
                    style={{ cursor: "pointer" }}
                    className="card-title log-dashboard-head "
                    onClick={() => openDashboard()}
                  >
                    <span>My Dashboard</span>
                  </h5>
                ) : data?.applicationStatus === "PENDING" ||
                  data?.applicationStatus === "" ||
                  data?.applicationStatus === null ? (
                  ""
                ) : 
                (
                  <h5
                    style={{ cursor: "pointer" }}
                    className="card-title log-dashboard-head "
                    onClick={() => openDashboard()}
                  >
                    <span>My Dashboard</span>
                  </h5>
                )}

                <p>
                  {" "}
                  <button
                    className="thm-logout"
                    onClick={() => logoutClick()}
                    title=""
                  >
                    Log Out
                  </button>
                </p>
              </div>
            </div>
          </div>
        </span>
      </div>
    </div>
  );
};

// const mapStateToProps = (state) => {
//   //
//   return {
//     DashboardMentorHomeList: state.MentorReducer.DashboardMentorHomeList.data,
//     // getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
//   };
// };

export default Profile;
// export default connect(mapStateToProps, {
//   getMentorHome,
//   // getPredefineOptionsList,
// })(withRouter(Profile));
